import { useEffect, useRef, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function OpeningSequence({ onComplete }) {
  const doneRef = useRef(false);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;
  const [done, setDone] = useState(false);

  const finish = useCallback(() => {
    if (doneRef.current) return;
    doneRef.current = true;
    setDone(true);
    setTimeout(() => onCompleteRef.current && onCompleteRef.current(), 550);
  }, []);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      if (onCompleteRef.current) onCompleteRef.current();
      return;
    }

    const timer = setTimeout(() => finish(), 2200);
    return () => clearTimeout(timer);
  }, [finish]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[999] flex items-center justify-center overflow-hidden bg-black"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          animate={{ opacity: done ? 0 : 1 }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <div className="relative flex items-center justify-center">
            <motion.div
              className="absolute h-44 w-44 rounded-full border border-primary/15"
              animate={{ scale: [1, 1.08, 1], opacity: [0.45, 0.75, 0.45] }}
              transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.div
              className="absolute h-32 w-32 rounded-full border border-primary/20"
              animate={{ rotate: 360 }}
              transition={{ duration: 3.8, repeat: Infinity, ease: "linear" }}
              style={{
                borderTopColor: "hsl(var(--primary))",
                borderRightColor: "transparent",
                borderBottomColor: "transparent",
                borderLeftColor: "transparent",
              }}
            />
            <motion.div
              className="absolute h-20 w-20 rounded-full border border-primary/25"
              animate={{ rotate: -360 }}
              transition={{ duration: 2.8, repeat: Infinity, ease: "linear" }}
              style={{
                borderTopColor: "transparent",
                borderRightColor: "hsl(var(--primary))",
                borderBottomColor: "transparent",
                borderLeftColor: "transparent",
              }}
            />
            <motion.div
              className="h-3 w-3 rounded-full bg-primary shadow-[0_0_30px_hsl(var(--signal)/0.8)]"
              animate={{ scale: [1, 1.35, 1], opacity: [1, 0.6, 1] }}
              transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>

          <motion.div
            className="absolute bottom-8 left-1/2 -translate-x-1/2 font-mono text-[0.68rem] uppercase tracking-[0.3em] text-primary/80"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Loading
          </motion.div>

          <button
            onClick={finish}
            className="absolute bottom-6 right-6 z-20 font-mono text-[0.68rem] uppercase tracking-[0.2em] text-white/40 transition-colors hover:text-white"
          >
            skip →
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
